import React, { useState, useEffect } from 'react';
import $, { event } from 'jquery'; 
import useSound from 'use-sound';
import teclados from './../sonidos/teclado.mp3';
import idtransmi from './../sonidos/idtransmi.mp3';
import pastransmi from './../sonidos/passtransmilenio.mp3';

export function LoginIngreso({ login, visibleTabla})  {

const [tecladoS] = useSound(teclados);
const [idtransmisonido] = useSound(idtransmi);
const [pastransmisonido] = useSound(pastransmi);
var selInput;
var valInput;

function borra(event){
    var valInput;
    
        if (selInput==='1'){
            valInput = $('#id').val();
            valInput= valInput.slice(0,-1);  
            $('#id').val(valInput);  
        }else{
            valInput = $('#contrasena').val();
            valInput = valInput.slice(0,-1)
            $('#contrasena').val(valInput);
        } 
}

const teclado = (event,num) =>{
  tecladoS();
    console.log('teclado'+num); 
    if (selInput==1){
        valInput = $('#id').val();       
         $('#id').val(valInput+num);     
      }else{
         valInput = $('#contrasena').val();       
        $('#contrasena').val(valInput+num);
      }
}

const setInput = ( event,inputL) =>{

    if(inputL==1){
      idtransmisonido();
      selInput=1;
    }else{
      pastransmisonido();
      selInput=2;
    }
}

return(
    
    <table className='tablalogin' height='275px' width='490px'  > 
    <tbody>
      <tr>
        <td colSpan={8}> <img alt='' src='assets/login/img_slice_0_0.png' className='img_slice_0_0' />         </td>
      </tr>
      <tr>
        <td> <img alt=' ' src='assets/login/img_slice_1_0.png' className='img_slice_1_0' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_1.png' className='img_slice_1_1' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_2.png' className='img_slice_1_2' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_3.png' className='img_slice_1_3' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_4.png' onClick={(event)=>teclado(event,1)} className='img_slice_1_4' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_5.png' onClick={(event)=>teclado(event,2)} className='img_slice_1_5' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_6.png' onClick={(event)=>teclado(event,3)} className='img_slice_1_6' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_1_7.png' className='img_slice_1_7' />         </td>
      </tr>
      <tr>
        <td> <img alt=' ' src='assets/login/img_slice_2_0.png' className='img_slice_2_0' />         </td>
        <td> <input id='id' onFocus={(event)=>setInput(event,1)} className='img_slice_2_1'  placeholder='Codigo Operador' type='text'/> </td>
        <td rowSpan={2}> <b className='botonok'> <img alt='Click Registrar'  onClick={login} src='assets/login/img_slice_2_2.png' className='img_slice_2_2' title="Ingresar" />
        </b><span className='tooltiptext'>Click<br/>Ingresar</span>
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_2_3.png' className='img_slice_2_3' />        </td>
        <td> <img alt=' ' src='assets/login/img_slice_2_4.png' onClick={(event)=>teclado(event,4)} className='img_slice_2_4' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_2_5.png' onClick={(event)=>teclado(event,5)} className='img_slice_2_5' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_2_6.png' onClick={(event)=>teclado(event,6)} className='img_slice_2_6' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_2_7.png' className='img_slice_2_7' />        </td>
      </tr>
      <tr>
        <td> <img alt=' ' src='assets/login/img_slice_3_0.png' className='img_slice_3_0' />        </td>
        <td> <input id='contrasena' onFocus={(event)=>setInput(event,2)} className='img_slice_3_1' type='text' placeholder='Contrasena Transmilenio'/> 
</td>
        <td> <img alt=' ' src='assets/login/img_slice_3_3.png' className='img_slice_3_2' />        </td>
        <td> <img alt=' ' src='assets/login/img_slice_3_4.png' onClick={(event)=>teclado(event,7)} className='img_slice_3_4' />
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_3_5.png' onClick={(event)=>teclado(event,8)} className='img_slice_3_5' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_3_6.png' onClick={(event)=>teclado(event,9)} className='img_slice_3_6' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_3_7.png' className='img_slice_3_7' />         </td>
      </tr>
      <tr>
        <td> <img alt=' ' src='assets/login/img_slice_4_0.png' className='img_slice_4_0' />        </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_1.png' className='img_slice_4_1' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_2.png' className='img_slice_4_2' />        </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_3.png' className='img_slice_4_3' />        </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_4.png' className='img_slice_4_4' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_5.png' onClick={(event)=>teclado(event,0)} className='img_slice_4_5' />  
        </td>
        <td> <img alt=' ' onClick={(event)=>borra(event)} src='assets/login/img_slice_4_6.png' className='img_slice_4_6' /> 
        </td>
        <td> <img alt=' ' src='assets/login/img_slice_4_7.png' className='img_slice_4_7' />         </td>
      </tr>
      <tr>
        <td> <img alt=' ' src='assets/login/img_slice_5_0.png' className='img_slice_5_0' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_1.png' className='img_slice_5_1' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_2.png' className='img_slice_5_2' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_3.png' className='img_slice_5_3' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_4.png' className='img_slice_5_4' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_5.png' className='img_slice_5_5' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_6.png' className='img_slice_5_6' />         </td>
        <td> <img alt=' ' src='assets/login/img_slice_5_7.png' className='img_slice_5_7' />         </td>
      </tr>
    </tbody>
  </table>       
  );

};